<div class="home-container" *ngIf="changePasswordForm" [formGroup]="changePasswordForm" (submit)="saveFormData()">
  <div class="header-section">
    <div class="title">{{'change-password.page-title' | translate}}</div>
    <i class="pi pi-times icon-buttons"
       (click)="closeDialog()"></i>
  </div>

  <div class="content-section">
    <div class="field-rows info-header">{{'change-password.info-header' | translate}}</div>
    <div class="field-rows">
      <input class="ui-input pInputText input-field"
             id="password-input-email"
             formControlName="email"
             pInputText placeholder="{{'change-password.email' | translate}}"
             size="30" type="text">
    </div>
    <div class="field-rows">
      <input class="ui-input pInputText input-field"
             id="password-input-old-value"
             formControlName="oldPassword"
             pPassword placeholder="{{'change-password.old-password' | translate}}"
             size="30" type="password" [showPassword]="showPasswordOne" [feedback]="false">
      <span class="show-password-container">
	            <i [ngClass]="showPasswordOne ? 'pi pi-eye-slash': 'pi pi-eye'"
                 (click)="showPasswordOne = !showPasswordOne"></i>
	        </span>
    </div>
    <div class="field-rows">
      <input class="ui-input pInputText input-field"
             id="password-input-new-value"
             formControlName="newPassword"
             pPassword placeholder="{{'change-password.new-password' | translate}}"
             size="30" type="password" [showPassword]="showPasswordTwo" [feedback]="false">
      <span class="show-password-container">
	            <i [ngClass]="showPasswordTwo ? 'pi pi-eye-slash': 'pi pi-eye'"
                 (click)="showPasswordTwo = !showPasswordTwo"></i>
	        </span>
    </div>
    <div class="field-rows">
      <input class="ui-input pInputText input-field"
             id="password-input-repeat-value"
             formControlName="repeatPassword"
             pPassword placeholder="{{'change-password.repeat-password' | translate}}"
             size="30" type="password" [showPassword]="showPasswordThree" [feedback]="false">
      <span class="show-password-container">
	            <i [ngClass]="showPasswordThree ? 'pi pi-eye-slash': 'pi pi-eye'"
                 (click)="showPasswordThree = !showPasswordThree"></i>
	        </span>
    </div>

    <div class="buttons-section">
      <button pButton type="button" class="submit-button"
              id="password-btn-submit"
              label="{{'change-password.submit-button-label' | translate}}" (click)="saveFormData()"
              [disabled]="disableSubmitButton"></button>

      <button pButton type="button" class="cancel-button"
              id="password-btn-cancel"
              label="{{'change-password.cancel-button-label' | translate}}" (click)="resetForm()"
              [disabled]="changePasswordForm.untouched"></button>
    </div>

    <div class="error-message" *ngIf="errorMessage">{{errorMessage | translate}}</div>
    <div class="success-message" *ngIf="successMessage"> {{successMessage | translate}}</div>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
